import * as React from 'react';
import { connect } from 'react-redux';
import { Redirect, Route, RouteComponentProps, Switch } from 'react-router-dom';

import { MapStateToProps } from '~commonInfra/utils/ConnectUtils';
import { AppState } from '~src/bootstrap/redux/state/AppState';
import { RouterError } from '~src/bootstrap/routerHelpers/RouterError';
import { RequestAccessType } from '~src/requestAccess/types/RequestAccessType';
import { SpacesSiteUrls } from '~src/spacesPlatform/components/spaceComponents/SpacesSiteUrls';
import { selectPreviousUrl } from '~src/spacesPlatform/selectors/NavigationStateSelectors';

import { HomeSpaceProvider, HomeSpaceProviderProps } from './HomeSpaceProvider';

export interface SpaceRouteParams {
  readonly id: string;
  readonly contentType: string;
}

export interface HomeRouteComponentProps extends RouteComponentProps<SpaceRouteParams> {}

export interface HomeSpaceRouterOwnProps {
  readonly siteName: string;
  readonly urls: SpacesSiteUrls;
}

export interface HomeSpaceRouterStateProps {
  readonly previousUrl: string;
}

export type HomeSpaceRouterProps = HomeRouteComponentProps & HomeSpaceRouterOwnProps & HomeSpaceRouterStateProps;

export class HomeSpaceRouterComponent extends React.Component<HomeSpaceRouterProps> {
  public render() {
    return (
      <Switch>
        <Route exact path={this.props.urls.homePath()} render={this.homeSpaceProvider()} />
        <Route exact path={this.props.urls.workbookPublishresultPath(':id')} render={({ match }) => (
          <Redirect to={this.props.urls.workbookViewsPath(match.params.id)} />
        )} />
        <Route exact path={this.props.urls.workbookRequestAccessPath(':id')} render={({ match }) => (
          <Redirect to={this.props.urls.homePath()} />
        )} />
        <Route exact path={this.props.urls.datasourceRequestAccessPath(':id')} render={({ match }) => (
          <Redirect to={this.props.urls.homePath()} />
        )} />
        <Route exact path={this.props.urls.collectionRequestAccessPath(':id')} render={({ match }) => (
          <Redirect to={this.props.urls.homePath()} />
        )} />
        <Route exact path={this.props.urls.flowRequestAccessPath(':id')} render={({ match }) => (
          <Redirect to={this.props.urls.homePath()} />
        )} />
        <Route exact path={this.props.urls.projectRequestAccessPath(':id')} render={({ match }) => (
          <Redirect to={this.props.urls.homePath()} />
        )} />
        <Route exact path={this.props.urls.viewRequestAccessPath(':id')} render={({ match }) => (
          <Redirect to={this.props.urls.homePath()} />
        )} />
        <Route exact path={this.props.urls.virtualConnectionRequestAccessPath(':id')} render={({ match }) => (
          <Redirect to={this.props.urls.homePath()} />
        )} />
        <Route exact path={this.props.urls.virtualConnectionTableRequestAccessPath(':id')} render={({ match }) => (
          <Redirect to={this.props.urls.homePath()} />
        )} />
        <Route path={this.props.urls.homePath()} render={({ match }) => (
          <Switch>
            {/* default redirect  */}
            <Redirect to={this.props.urls.homePath()} />
          </Switch>
        )} />
        <Route render={this.error} />
      </Switch>
    );
  }

  private homeSpaceProvider = (): (props: HomeRouteComponentProps) => JSX.Element => {
    return (props: HomeRouteComponentProps): JSX.Element => {

      const indexOfIdentifier = this.props.previousUrl.lastIndexOf('/');
      let identifier = this.props.previousUrl.substring(indexOfIdentifier +1);
      let type = '' as RequestAccessType;
      let requestAccessDisplay = false;
      const previousUrl = this.props.previousUrl;
        if (this.props.previousUrl.includes(this.props.urls.workbookRequestAccessPath(identifier))) {
          type = 'workbook' as RequestAccessType;
          requestAccessDisplay = true;
        } else if (this.props.previousUrl.includes(this.props.urls.datasourceRequestAccessPath(identifier))) {
          type = 'datasource' as RequestAccessType;
          requestAccessDisplay = true;
        } else if (this.props.previousUrl.includes(this.props.urls.collectionRequestAccessPath(identifier))) {
          type = 'collection' as RequestAccessType;
          requestAccessDisplay = true;
        } else if (this.props.previousUrl.includes(this.props.urls.flowRequestAccessPath(identifier))) {
          type = 'flow' as RequestAccessType;
          requestAccessDisplay = true;
        } else if (this.props.previousUrl.includes(this.props.urls.projectRequestAccessPath(identifier))) {
          type = 'project' as RequestAccessType;
          requestAccessDisplay = true;
        } else if (this.props.previousUrl.includes(this.props.urls.virtualConnectionRequestAccessPath(identifier))) {
          type = 'virtualConnection' as RequestAccessType;
          requestAccessDisplay = true;
        } else if (this.props.previousUrl.includes(this.props.urls.virtualConnectionTableRequestAccessPath(identifier))) {
          type = 'virtualConnectionTable' as RequestAccessType;
          requestAccessDisplay = true;
        } else {
          const requestAccessViewString = 'requestAccess/views/';
          const viewIndex = this.props.previousUrl.lastIndexOf(requestAccessViewString);
          const viewIdentifier = this.props.previousUrl.substring(viewIndex + requestAccessViewString.length);
          if (this.props.previousUrl.includes(this.props.urls.viewRequestAccessPath(viewIdentifier))) {
            type = 'view' as RequestAccessType;
            requestAccessDisplay = true;
            identifier = viewIdentifier;
          }
        }
      const homeSpaceProviderProps: HomeSpaceProviderProps = {
        siteName: this.props.siteName,
        routeLocationPath: props.location.pathname,
        routeLocationSearch: props.location.search,
        requestAccessDisplay,
        requestAccessContent: {identifier, type,},
        requestAccessUrl: requestAccessDisplay ? this.props.previousUrl : '',
      };

      return <HomeSpaceProvider {...homeSpaceProviderProps} />;
    };
  };

  private error = (): JSX.Element => {
    return <RouterError errorType={'default'} urls={this.props.urls}/>;
  };
}

const mapStateToProps: MapStateToProps<HomeSpaceRouterStateProps> = (state: AppState) => ({
  previousUrl: selectPreviousUrl(state),
});

// Component must *not* be pure as to allow route updates to flow through
export const HomeSpaceRouter: React.ComponentClass<HomeSpaceRouterOwnProps>
  = connect(mapStateToProps, null, null, {pure: false})(HomeSpaceRouterComponent);
